<template>
  <adresse
    :carte-affaire="carteAffaire"
    :addressComplete="addressComplete"
    adresseCode="emploi-adresse"
    complementAdresseCode="emploi-complement-adresse"
    noteAccesCode="emploi-note-acces"
    villeCode="emploi-ville"
    codePostalCode="emploi-code-postal"
    provinceCode="emploi-province"
    paysCode="emploi-pays"
    telephoneCode="emploi-telephone"
    posteTelephoniqueCode="emploi-poste-telephonique"
    courrielCode="emploi-courriel"
    :courrielOptional="true"
    :two-columns="twoColumns"
    :live="live"
    :disabled="disabled"
    ref="adresse"
  ></adresse>
</template>

<script>
import Adresse from "@/components/FormParts/Adresse"

export default {
  components: { Adresse },
  props: {
    carteAffaire: { type: Object },
    addressComplete: { type: Boolean, default: true },
    twoColumns: { type: Boolean, default: false },
    live: { type: Boolean, default: true },
    disabled: { type: Boolean, default: false }
  }
}
</script>

<style>
</style>